import{b as I}from"./chunk.F777AQ4E.js";import{c as k}from"./chunk.B2DTUPGR.js";import{b as x}from"./chunk.CUOPQL3Y.js";import{a as p}from"./chunk.2AIXLGYE.js";import{a as t}from"./chunk.NFEB7TIJ.js";import{a as d}from"./chunk.XPINZPW5.js";import{a as m}from"./chunk.65JZXZ5X.js";import{d as g}from"./chunk.DQ7YBHX4.js";import{c as i}from"./chunk.NWIV65VP.js";import{html as M}from"lit/static-html.js";import{queryAssignedElements as T}from"lit/decorators.js";import{html as c}from"lit/static-html.js";import{property as u,queryAssignedElements as $,state as f}from"lit/decorators.js";import{classMap as A}from"lit/directives/class-map.js";import{ifDefined as L}from"lit/directives/if-defined.js";import{when as b}from"lit/directives/when.js";import{css as w}from"lit";var y=w`
  ${p}

  :host {
    --x-padding: var(--he-spacing-x-small);
    --icon-slot-size: 32px;

    display: block;
    overflow: visible;
    outline: none;
    height: var(--he-menu-control-height);
    padding: 0;
    margin: 0;
    white-space: nowrap;
    color: var(--he-neutral-foreground);
    fill: currentColor;
    cursor: pointer;
    font-size: var(--he-font-size-medium);
    line-height: var(--he-line-height-normal);
    user-select: none;
  }

  .menu-item {
    display: grid;
    grid-template-columns: minmax(var(--x-padding), auto) auto 1fr minmax(var(--x-padding), auto) auto;
    grid-template-rows: 1fr;
    justify-items: center;
    align-items: center;
    height: 100%;
  }

  /* quick nav indents are one off because they are radios but hide the radio icon */
  .menu-item--indent-1:not(.menu-item--quicknav),
  .menu-item--quicknav.menu-item--indent-2 {
    grid-template-columns: var(--icon-slot-size) auto 1fr minmax(var(--x-padding), auto) auto;
  }

  .menu-item--indent-2:not(.menu-item--quicknav) {
    grid-template-columns: var(--icon-slot-size) var(--icon-slot-size) 1fr minmax(var(--x-padding), auto) auto;
  }

  :host(:focus-visible) .menu-item {
    box-shadow: inset var(--he-focus-ring);
  }

  :host(:hover:not([disabled])) {
    background-color: var(--he-neutral-fill-stealth-hover);
  }

  :host(:active:not([disabled])),
  :host([expanded]) {
    background-color: var(--he-neutral-fill-stealth-active);
  }

  :host([disabled]) {
    cursor: 'not-allowed';
    opacity: var(--he-form-control-disabled-opacity);
  }

  :host([disabled]:hover) .start,
  :host([disabled]:hover) .end,
  :host([disabled]:hover)::slotted(svg) {
    fill: currentColor;
  }

  .content {
    grid-column-start: 3;
    justify-self: start;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .start,
  .end {
    display: flex;
    justify-content: center;
    pointer-events: none;
  }

  .start {
    color: var(--he-accent-foreground-rest);
  }

  .end {
    min-width: var(--icon-slot-size);
    margin-inline-start: var(--he-spacing-2x-small);
    color: var(--he-type-secondary);
  }

  .expand-collapse-glyph-container {
    min-width: var(--icon-slot-size);
    justify-content: center;
    pointer-events: none;
  }

  ::slotted([slot='expand-collapse-indicator']),
  .expand-collapse-glyph {
    font-size: var(--he-chevron-size);
    fill: var(--he-color-neutral-600);
    color: var(--he-color-neutral-600);
  }

  .menu-item--rtl .expand-collapse-glyph {
    transform: rotate(180deg);
  }

  :host(:hover) .start,
  :host(:hover)::slotted(.he-icon[slot='start']) {
    color: var(--he-accent-foreground-hover);
  }

  :host(:active) .start,
  :host(:active)::slotted(.he-icon[slot='start']) {
    color: var(--he-accent-foreground-active);
  }

  ::slotted(svg) {
    width: var(--he-icon-size);
    height: var(--he-icon-size);
    display: flex;
  }

  :host(:hover)::slotted(svg[slot='start']) {
    fill: var(--he-accent-foreground-hover);
  }

  :host(:active)::slotted(svg[slot='start']) {
    fill: var(--he-accent-foreground-active);
  }

  .input-container,
  .expand-collapse-glyph-container {
    display: none;
  }

  :host([role='menuitemcheckbox']) .input-container,
  :host([role='menuitemradio']) .input-container {
    display: grid;
  }

  :host([aria-haspopup='menu']) .expand-collapse-glyph-container {
    display: grid;
  }

  :host([aria-haspopup='menu']) .end,
  :host([role='menuitemcheckbox']) .end,
  :host([role='menuitemradio']) .end {
    grid-column-start: 4;
  }

  .expand-collapse,
  .checkbox,
  .radio {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    outline: none;
  }

  .radio {
    border-radius: 999px;
    position: relative;
    background-color: var(--he-color-surface-background);
    border: var(--he-form-control-border-width) solid var(--he-color-neutral-600);
  }

  :host(:hover) .radio {
    border-color: var(--he-color-neutral-700);
  }

  :host(:active) .radio {
    border-color: var(--he-color-neutral-800);
  }

  .checkbox-indicator,
  .radio-indicator,
  ::slotted([slot='checkbox-indicator']),
  ::slotted([slot='radio-indicator']),
  ::slotted([slot='expand-collapse-indicator']) {
    display: none;
  }

  :host([aria-checked='true']) .checkbox-indicator,
  :host([aria-checked='true']) ::slotted([slot='checkbox-indicator']) {
    width: var(--he-icon-size);
    height: var(--he-icon-size);
    display: block;
    fill: var(--he-color-neutral-800);
    color: var(--he-color-neutral-800);
    pointer-events: none;
  }

  :host([aria-checked='true']) .radio {
    border-color: var(--he-accent-fill-rest);
  }

  :host([aria-checked='true']:hover) .radio {
    border-color: var(--he-accent-fill-hover);
  }

  :host([aria-checked='true']:active) .radio {
    border-color: var(--he-accent-fill-active);
  }

  :host([aria-checked='true']) .radio-indicator {
    position: absolute;
    inset: 4px;
    border-radius: 999px;
    display: inline-block;
    background: var(--he-accent-fill-rest);
    pointer-events: none;
  }

  :host([aria-checked='true']:hover) .radio-indicator {
    background: var(--he-accent-fill-hover);
  }

  :host([aria-checked='true']:active) .radio-indicator {
    background: var(--he-accent-fill-active);
  }

  :host([aria-checked='true']) ::slotted([slot='radio-indicator']) {
    display: block;
    pointer-events: none;
  }

  :host(:not([disabled]):hover) .menu-item--quicknav {
    color: var(--he-accent-foreground-rest);
  }

  :host(:not([disabled]):active) .menu-item--quicknav {
    color: var(--he-neutral-foreground);
  }

  :host([aria-checked='true']) .menu-item--quicknav {
    background-color: var(--he-neutral-fill-stealth-active);
    position: relative;
  }

  :host([aria-checked='true']) .menu-item--quicknav::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 3px;
    background: var(--he-accent-foreground-rest);
  }

  .menu-item--quicknav.menu-item--rtl::after {
    right: -1px;
    left: auto;
  }

  .menu-item--quicknav .input-container {
    display: none;
  }

  @media screen and (forced-colors: active) {
    :host,
    .popup {
      forced-color-adjust: none;
    }

    :host {
      background-color: ${t.ButtonFace};
      color: ${t.ButtonText};
      border-color: ${t.ButtonText};
    }

    ::slotted(*) {
      color: ${t.ButtonText};
      fill: currentColor;
    }

    :host(:hover:not([disabled])),
    :host(:active:not([disabled])),
    :host(:hover:not([disabled])) .he-icon,
    :host(:active:not([disabled])) .he-icon,
    :host(:hover:not([disabled])) ::slotted(*),
    :host(:active:not([disabled])) ::slotted(*) {
      background-color: ${t.Highlight};
      color: ${t.HighlightText};
    }

    :host([expanded]),
    :host([expanded]) .he-icon,
    :host([expanded]) ::slotted(*) {
      background-color: ${t.Highlight};
      border-color: ${t.Highlight};
      color: ${t.HighlightText};
    }

    :host(:focus-visible) {
      box-shadow: 0 0 0 var(--he-focus-ring-width) inset ${t.ButtonText};
    }

    :host(:focus-visible),
    :host(:focus-visible) .he-icon,
    :host(:focus-visible) ::slotted(*) {
      background: ${t.Highlight};
      color: ${t.HighlightText};
    }

    :host([disabled]),
    :host([disabled]) .he-icon,
    :host([disabled]) ::slotted(*) {
      background: ${t.Canvas};
      color: ${t.GrayText};
      opacity: 1;
    }

    .radio {
      border-color: ${t.ButtonText};
    }

    :host([aria-checked='true']),
    :host([aria-checked='true']) .he-icon,
    :host([aria-checked='true']) .radio,
    :host([aria-checked='true']) ::slotted(*) {
      background: ${t.Highlight};
      color: ${t.HighlightText};
    }

    :host(:hover) .radio,
    :host(:focus-visible) .radio,
    :host([aria-checked='true']) .radio {
      border-color: ${t.HighlightText};
    }

    :host([aria-checked='true']) .radio-indicator,
    :host([aria-checked='true']:hover) .radio-indicator {
      background: ${t.HighlightText};
    }

    :host([aria-checked='true']) .checkbox-indicator,
    :host([aria-checked='true']) ::slotted([slot='checkbox-indicator']),
    :host([aria-checked='true']) ::slotted([slot='radio-indicator']) {
      color: ${t.HighlightText};
    }
  }
`;var o=class extends m{constructor(){super();this.scope=g(this);this.hasSubmenu=!1;this.startColumnCount=0;this.quickNav=!1;this.disabled=!1;this.expanded=!1;this.role="menuitem";this.submenuFixedPlacement=!1;this.handleMenuItemKeyDown=e=>{if(e.defaultPrevented)return!1;switch(e.key){case"Enter":case" ":return this.click(),e.preventDefault(),!1;case"ArrowRight":return this.expandAndFocus(),e.preventDefault(),!1;case"ArrowLeft":if(this.expanded)return this.expanded=!1,this.focus(),e.preventDefault(),!1}return!0};this.handleMenuItemClick=e=>e.defaultPrevented||this.disabled?!1:(this.invoke(),!0);this.handleMouseOver=e=>(this.disabled||!this.hasSubmenu||this.expanded||(this.expanded=!0),!1);this.handleMouseOut=e=>(!this.expanded||this.contains(document.activeElement)||e.target!==this&&this.contains(this.querySelector(":hover"))||(this.expanded=!1),!1);this.expandAndFocus=async()=>{!this.hasSubmenu||(this.expanded=!0,await this.updateComplete,this.submenu.focus(),this.setAttribute("tabindex","-1"))};this.handleSubmenuSlotChange=()=>{this.slottedMenus[0]?this.submenu=this.slottedMenus[0]:this.submenu=void 0};this.handleStartSlotChange=()=>{this.parentElement instanceof h&&this.parentElement.setItems()};this.scope.registerComponent(x,I)}disabledChanged(){this.disabled?this.setAttribute("aria-disabled","true"):this.removeAttribute("aria-disabled")}expandedChanged(){this.hasSubmenu?this.setAttribute("aria-expanded",this.expanded.toString()):this.removeAttribute("aria-expanded"),this.hasSubmenu&&this.emit("he-expanded-change",{bubbles:!1})}roleChanged(){this.parentElement instanceof h&&this.parentElement.setItems()}checkedChanged(){this.role!=="menuitem"?this.setAttribute("aria-checked",(!!this.checked).toString()):this.removeAttribute("aria-checked"),this.emit("he-change")}submenuChanged(){this.hasSubmenu=!!this.submenu&&this.role==="menuitem",this.hasSubmenu?this.setAttribute("aria-haspopup","menu"):this.removeAttribute("aria-haspopup")}connectedCallback(){super.connectedCallback(),this.addEventListener("keydown",this.handleMenuItemKeyDown),this.addEventListener("click",this.handleMenuItemClick),this.addEventListener("mouseover",this.handleMouseOver),this.addEventListener("mouseout",this.handleMouseOut)}disconnectedCallback(){super.disconnectedCallback(),this.removeEventListener("keydown",this.handleMenuItemKeyDown),this.removeEventListener("click",this.handleMenuItemClick),this.removeEventListener("mouseover",this.handleMouseOver),this.removeEventListener("mouseout",this.handleMouseOut),this.submenu=void 0}firstUpdated(){this.role!=="menuitem"&&this.setAttribute("aria-checked",(!!this.checked).toString())}invoke(){if(!this.disabled)switch(this.role){case"menuitemcheckbox":this.checked=!this.checked;break;case"menuitem":this.hasSubmenu?this.expandAndFocus():this.emit("he-change");break;case"menuitemradio":this.checked||(this.checked=!0);break}}render(){let e=c`
      <div
        slot=${L(this.hasSubmenu?"anchor":void 0)}
        part="base"
        class=${A({"menu-item":!0,"menu-item--disabled":this.disabled,"menu-item--expanded":this.expanded,[`menu-item--indent-${this.startColumnCount}`]:!0,"menu-item--quicknav":this.quickNav,[`menu-item--${this.dir}`]:!0})}
      >
        ${b(this.role==="menuitemcheckbox",()=>c`
        <div part="input-container" class="input-container">
          <span part="checkbox" class="checkbox">
            <slot name="checkbox-indicator">
              <${this.scope.tag("icon")}
                name="checkmark"
                part="checkbox-indicator"
                class="checkbox-indicator"
              ></${this.scope.tag("icon")}>
            </slot>
          </span>
        </div>
      `)}
        ${b(this.role==="menuitemradio"&&!this.quickNav,()=>c`
            <div part="input-container" class="input-container">
              <span part="radio" class="radio">
                <slot name="radio-indicator">
                  <span part="radio-indicator" class="radio-indicator"></span>
                </slot>
              </span>
            </div>
          `)}
        <span part="start" class="start">
          <slot name="start" @slotchange=${this.handleStartSlotChange}></slot>
        </span>
        <span class="content" part="content">
          <slot></slot>
        </span>
        <span part="end" class="end">
          <slot name="end"></slot>
        </span>
        ${b(this.hasSubmenu,()=>c`
            <div part="expand-collapse-glyph-container" class="expand-collapse-glyph-container">
              <span part="expand-collapse" class="expand-collapse">
                <slot name="expand-collapse-indicator">
                  <${this.scope.tag("icon")}
                    name="ChevronRight"
                    class="expand-collapse-glyph"
                    part="expand-collapse-glyph"
                  ></${this.scope.tag("icon")}>
                </slot>
              </span>
            </div>
          `)}
      </div>
    `;return c`
      ${b(this.hasSubmenu,()=>c`
          <${this.scope.tag("popup")}
            ?active=${this.expanded}
            placement=${this.dir==="rtl"?"left-start":"right-start"}
            flip
            flip-fallback-strategy="best-fit"
            flip-fallback-placements="left right bottom top"
            strategy=${this.submenuFixedPlacement?"fixed":"absolute"}
            part="popup"
            class="popup"
          >
            ${e}

            <slot name="submenu" @slotchange=${this.handleSubmenuSlotChange}></slot>
          </${this.scope.tag("popup")}>
        `,()=>c`
          ${e}
          <div hidden><slot name="submenu" @slotchange=${this.handleSubmenuSlotChange}></slot></div>
        `)}
    `}};o.styles=[y],o.baseName="menu-item",o.reactEvents={onHeChange:new CustomEvent("he-change"),onHeExpandedChange:new CustomEvent("he-expanded-change")},i([f()],o.prototype,"hasSubmenu",2),i([f()],o.prototype,"startColumnCount",2),i([f()],o.prototype,"quickNav",2),i([$({slot:"submenu",selector:'[role="menu"]',flatten:!0})],o.prototype,"slottedMenus",2),i([u({attribute:"nav-to"})],o.prototype,"navTo",2),i([u({attribute:"nav-target"})],o.prototype,"navTarget",2),i([u({type:Boolean,reflect:!0})],o.prototype,"disabled",2),i([d("disabled")],o.prototype,"disabledChanged",1),i([u({type:Boolean,reflect:!0})],o.prototype,"expanded",2),i([d("expanded"),d("hasSubmenu")],o.prototype,"expandedChanged",1),i([u({reflect:!0})],o.prototype,"role",2),i([d("role")],o.prototype,"roleChanged",1),i([u({type:Boolean,reflect:!0})],o.prototype,"checked",2),i([d("checked",{waitUntilFirstUpdate:!0}),d("role",{waitUntilFirstUpdate:!0})],o.prototype,"checkedChanged",1),i([u({attribute:"submenu-fixed-placement",type:Boolean,reflect:!0})],o.prototype,"submenuFixedPlacement",2),i([f()],o.prototype,"submenu",2),i([d("submenu"),d("role")],o.prototype,"submenuChanged",1);var W=o;import{css as S}from"lit";var E=S`
  ${p}

  :host {
    --he-elevation: 11;
    ${k}
    display: block;
    background: var(--he-color-surface-background);
    border-radius: var(--he-menu-control-border-radius);
    margin: 0;
    padding: 0;
    max-width: 368px;
    min-width: 180px;
    width: max-content;
  }

  ::slotted(hr) {
    box-sizing: content-box;
    height: 0;
    margin: 0;
    border: none;
    border-top: var(--he-form-control-border-width) solid var(--he-color-neutral-200);
  }

  ::slotted(.he-menu-item:first-child) {
    border-top-left-radius: var(--he-menu-control-border-radius);
    border-top-right-radius: var(--he-menu-control-border-radius);
  }

  ::slotted(.he-menu-item:last-child) {
    border-bottom-left-radius: var(--he-menu-control-border-radius);
    border-bottom-right-radius: var(--he-menu-control-border-radius);
  }

  @media screen and (forced-colors: active) {
    :host {
      background: ${t.Canvas};
      color: ${t.CanvasText};
      border: 1px solid ${t.CanvasText};
    }
  }
`;var h=class extends m{constructor(){super(...arguments);this.expandedItem=null;this.focusIndex=-1;this.isNestedMenu=()=>{var e;return this.parentElement!==null&&this.parentElement instanceof HTMLElement&&(((e=this.parentElement.getAttribute("role"))==null?void 0:e.startsWith("menuitem"))||!1)};this.handleMenuKeyDown=e=>{if(!(e.defaultPrevented||this.menuItems===void 0))switch(e.key){case"ArrowDown":this.setFocus(this.focusIndex+1,1),e.preventDefault();return;case"ArrowUp":this.setFocus(this.focusIndex-1,-1),e.preventDefault();return;case"End":this.setFocus(this.menuItems.length-1,-1),e.preventDefault();return;case"Home":this.setFocus(0,1),e.preventDefault();return;default:return!0}};this.handleFocusOut=e=>{if(!this.contains(e.relatedTarget)&&this.menuItems!==void 0){this.collapseExpandedItem();let n=0;this.menuItems[this.focusIndex].setAttribute("tabindex","-1"),this.menuItems[n].setAttribute("tabindex","0"),this.focusIndex=n}};this.handleItemFocus=e=>{let n=e.target;this.menuItems!==void 0&&n!==this.menuItems[this.focusIndex]&&(this.menuItems[this.focusIndex].setAttribute("tabindex","-1"),this.focusIndex=this.menuItems.indexOf(n),n.setAttribute("tabindex","0"))};this.handleExpandedChanged=e=>{if(e.defaultPrevented||e.target===null||this.menuItems===void 0||this.menuItems.indexOf(e.target)<0)return;e.preventDefault();let n=e.target;if(this.expandedItem!==null&&n===this.expandedItem&&n.expanded===!1){this.expandedItem=null;return}n.expanded&&(this.expandedItem!==null&&this.expandedItem!==n&&(this.expandedItem.expanded=!1),this.menuItems[this.focusIndex].setAttribute("tabindex","-1"),this.expandedItem=n,this.focusIndex=this.menuItems.indexOf(n),n.setAttribute("tabindex","0"))};this.removeItemListeners=()=>{this.menuItems!==void 0&&this.menuItems.forEach(e=>{e.removeEventListener("he-expanded-change",this.handleExpandedChanged),e.removeEventListener("focus",this.handleItemFocus)})};this.handleSlotChange=()=>{this.isConnected&&this.menuItems!==void 0&&this.setItems(),this.isNestedMenu()?this.setAttribute("slot","submenu"):this.getAttribute("slot")==="submenu"&&this.removeAttribute("slot")};this.setItems=()=>{let e=this.domChildren();this.removeItemListeners(),this.menuItems=e;let n=this.menuItems.filter(this.isMenuItemElement);n.length&&(this.focusIndex=0);function l(s){let r=s.getAttribute("role"),a=s.querySelector("[slot=start]");return r!=="menuitem"&&a===null||r==="menuitem"&&a!==null?1:r!=="menuitem"&&a!==null?2:0}let v=n.reduce((s,r)=>{let a=l(r);return s>a?s:a},0);n.forEach((s,r)=>{s.setAttribute("tabindex",r===0?"0":"-1"),s.addEventListener("he-expanded-change",this.handleExpandedChanged),s.addEventListener("focus",this.handleItemFocus),s instanceof o&&(s.startColumnCount=v)})};this.handleChange=e=>{if(this.menuItems===void 0)return;let n=e.target,l=this.menuItems.indexOf(n);if(l!==-1&&n.role==="menuitemradio"&&n.checked===!0){for(let s=l-1;s>=0;--s){let r=this.menuItems[s],a=r.getAttribute("role");if(a==="menuitemradio"&&(r.checked=!1),a==="separator")break}let v=this.menuItems.length-1;for(let s=l+1;s<=v;++s){let r=this.menuItems[s],a=r.getAttribute("role");if(a==="menuitemradio"&&(r.checked=!1),a==="separator")break}}};this.isMenuItemElement=e=>e instanceof HTMLElement&&["menuitem","menuitemcheckbox","menuitemradio"].includes(e.getAttribute("role"))}connectedCallback(){super.connectedCallback(),this.setAttribute("role","menu"),setTimeout(()=>{this.setItems()}),this.addEventListener("he-change",this.handleChange),this.addEventListener("keydown",this.handleMenuKeyDown),this.addEventListener("focusout",this.handleFocusOut)}disconnectedCallback(){super.disconnectedCallback(),this.removeItemListeners(),this.menuItems=void 0,this.removeEventListener("he-change",this.handleChange),this.removeEventListener("keydown",this.handleMenuKeyDown),this.removeEventListener("focusout",this.handleFocusOut)}focus(){this.setFocus(0,1)}collapseExpandedItem(){this.expandedItem!==null&&(this.expandedItem.expanded=!1,this.expandedItem=null)}domChildren(){return Array.from(this.children).filter(e=>!e.hasAttribute("hidden"))}setFocus(e,n){if(this.menuItems!==void 0)for(;e>=0&&e<this.menuItems.length;){let l=this.menuItems[e];if(this.isMenuItemElement(l)){this.focusIndex>-1&&this.menuItems.length>=this.focusIndex-1&&this.menuItems[this.focusIndex].setAttribute("tabindex","-1"),this.focusIndex=e,l.setAttribute("tabindex","0"),l.focus();break}e+=n}}render(){return M`<slot @slotchange=${this.handleSlotChange}></slot>`}};h.styles=[E],h.baseName="menu",h.reactEvents={},i([T()],h.prototype,"items",2);var ae=h;export{h as a,ae as b,o as c,W as d};
